import { notis } from "./notificaciones.js";
import { COUNTRY_CODES } from "./countrySelector.js";
import solicitudes from "./solicitudes.js";

const validacionesComunes = {
  validarEmpty(campos) {
    const camposPresentes = Object.keys(campos);

    for (const nombreCampo of camposPresentes) {
      const valor = campos[nombreCampo];
      if (
        valor === "" ||
        valor === undefined ||
        valor === null ||
        valor === "default"
      ) {
        notis("warning", "El campo " + nombreCampo + " está vacío");
        return false;
      }
    }
    return true;
  },

  validarRTN(rtn) {
    const soloNumeros = /^\d+$/.test(rtn);
    if (!soloNumeros || rtn.length !== 14) {
      notis("warning", "RTN inválido");
      return false;
    }
    return true;
  },

  validarSelect(valor, campo) {
    if (
      !valor ||
      valor === "default" ||
      valor === undefined ||
      valor === null ||
      valor === ""
    ) {
      notis("warning", `Debe seleccionar: ${campo}`);
      return false;
    }
    return true;
  },

  validarNombre(nombre) {
    const caracteresPattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s-]+$/;
    if (!caracteresPattern.test(nombre)) {
      notis("warning", `El nombre tiene caracteres no permitidos`);
      return false;
    }

    if (nombre.length < 3 || nombre.length > 50) {
      notis("warning", `El nombre debe tener entre 3 y 50 caracteres`);
      return false;
    }

    return true;
  },

  validarDireccion(direccion) {
    if (direccion.length < 10 || direccion.length > 150) {
      notis("warning", `La direccion debe tener entre 10 y 150 caracteres`);
      return false;
    }

    return true;
  },

  validarNumero(valor, campo) {
    const n = Number(valor);
    if (isNaN(n)) {
      notis("warning", `El campo ${campo} debe ser un número`);
      return false;
    }
    if (n <= 0) {
      notis("warning", `El campo ${campo} debe ser mayor a 0`);
      return false;
    }
    return true;
  },

  validarEmail(email) {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!pattern.test(email)) {
      console.log("Correo inválido");
      notis("warning", "El correo electrónico ingresado no es válido");
      return false;
    }
    return true;
  },

  validarDescripcion(descripcion) {
    const descPattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s.,;:()\-_!¡¿?""'']+$/;
    if (!descPattern.test(descripcion)) {
      notis("warning", "La descripción contiene caracteres no permitidos");
      return false;
    }

    if (descripcion.length < 10 || descripcion.length > 200) {
      notis("warning", "La descripción debe tener entre 10 y 200 caracteres");
      return false;
    }

    return true;
  },

  validarTelefono(telefono, codigoPais) {
    const numeroLimpio = telefono.replace(/[\s-]/g, "");
    const config = COUNTRY_CODES[codigoPais];

    if (!config) {
      notis("warning", "País no soportado");
      return false;
    }

    const soloNumeros = /^\d+$/.test(numeroLimpio);
    if (!soloNumeros) {
      notis("warning", "El teléfono solo debe contener números");
      return false;
    }

    if (numeroLimpio.length !== config.length) {
      notis(
        "warning",
        `El teléfono debe tener ${config.length} dígitos para ${codigoPais}`
      );
      return false;
    }

    return true;
  },

  validarPass(password1, password2) {
    if (password1 !== password2) {
      notis("warning", "Las contraseñas no coinciden");
      return false;
    }
    return true;
  },

  validarPasswordSegura(password) {
    const pattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    if (!pattern.test(password)) {
      notis(
        "warning",
        "La contraseña debe tener al menos 8 caracteres, incluir una letra mayúscula, una letra minúscula, un número y un símbolo."
      );
      return false;
    }
    return true;
  },
};

const validacionesUsuario = {
  async validarDuplicados(form, isEditing = false) {
    try {
      const parametros = `/usuario/validar${
        isEditing ? "/" + form.id_usuario : ""
      }`;
      const response = await solicitudes.postRegistroAuth(parametros, {
        nombre_usuario: form.nombre_usuario,
        correo: form.correo,
      });

      if (response && response.error) {
        notis("error", response.error);
        return false;
      }

      if (response && response.duplicados) {
        if (response.duplicados.includes("nombre_usuario")) {
          notis(
            "warning",
            "El nombre de usuario ya está registrado en el sistema"
          );
          return false;
        }
        // Al editar, el correo no se re-valida (puede estar duplicado en la BD por datos históricos).
        // Solo bloqueamos duplicado de correo al CREAR un usuario nuevo.
        if (!isEditing && response.duplicados.includes("correo")) {
          notis(
            "warning",
            "El correo electrónico ya está registrado en el sistema"
          );
          return false;
        }
      }

      return true;
    } catch (error) {
      notis("error", "Error al validar la información del usuario");
      return false;
    }
  },

  async validarCampos(form, isPassEdit, selectedCountry, isEditing = false) {
    const campos = {
      Nombre: form.nombre,
      Apellido: form.apellido,
      "Nombre de Usuario": form.nombre_usuario,
      Correo: form.correo,
      Rol: form.rol,
      Contraseña: form.password,
      "Confirmar Contraseña": form.confirmPassword,
      Telefono: form.telefono,
      Direccion: form.direccion,
      Sucursal: form.sucursal,
    };

    const campos2 = {
      Nombre: form.nombre,
      Apellido: form.apellido,
      "Nombre de Usuario": form.nombre_usuario,
      Correo: form.correo,
      Rol: form.rol,
      Telefono: form.telefono,
      Direccion: form.direccion,
      Sucursal: form.sucursal,
    };

    if (isPassEdit) {
      if (!validacionesComunes.validarEmpty(campos)) return false;
    } else {
      if (!validacionesComunes.validarEmpty(campos2)) return false;
    }

    if (!validacionesComunes.validarNombre(campos.Nombre)) return false;

    const nombrePattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{3,50}$/;
    if (!nombrePattern.test(form.apellido)) {
      notis(
        "warning",
        "El apellido debe contener solo letras y tener al menos 3 caracteres"
      );
      return false;
    }

    const usernamePattern = /^[a-zA-Z0-9_]+$/;
    if (!usernamePattern.test(campos["Nombre de Usuario"])) {
      notis(
        "warning",
        "El nombre de usuario solo puede contener letras, números y guiones bajos"
      );
      return false;
    }
    if (
      campos["Nombre de Usuario"].length < 3 ||
      campos["Nombre de Usuario"].length > 50
    ) {
      notis(
        "warning",
        "El nombre de usuario debe tener entre al menos 3 caracteres"
      );
      return false;
    }

    // Al editar, el correo ya fue validado al crear el usuario.
    // Solo exigimos que no esté vacío (cubierto por validarEmpty arriba).
    if (!isEditing) {
      if (!validacionesComunes.validarEmail(campos.Correo)) return false;
    }

    // Validar duplicados
    if (!(await this.validarDuplicados(form, isEditing))) return false;

    if (!validacionesComunes.validarSelect(campos.Rol, "Rol")) return false;

    if (isPassEdit) {
      if (!validacionesComunes.validarPasswordSegura(campos.Contraseña))
        return false;
      if (
        !validacionesComunes.validarPass(
          campos.Contraseña,
          campos["Confirmar Contraseña"]
        )
      )
        return false;
    }

    if (!validacionesComunes.validarTelefono(campos.Telefono, selectedCountry))
      return false;

    // Al editar, la dirección ya fue validada al crear el usuario.
    // Solo exigimos que no esté vacía (cubierto por validarEmpty arriba).
    if (!isEditing) {
      if (!validacionesComunes.validarDireccion(campos.Direccion)) return false;
    }

    if (!validacionesComunes.validarSelect(campos.Sucursal, "Sucursal"))
      return false;

    return true;
  },
};

const validacionesCategorias = {
  validarCampos(form) {
    const campos = {
      Nombre: form.nombre_categoria,
      Descripción: form.descripcion,
    };

    if (!validacionesComunes.validarEmpty(campos)) return false;

    if (!validacionesComunes.validarNombre(campos.Nombre)) return false;

    if (!validacionesComunes.validarDescripcion(campos.Descripción))
      return false;

    return true;
  },
};

const validacionesSucursal = {
  validarCampos(form, selectedCountry) {
    const campos = {
      Nombre: form.nombre_administrativo,
      Correo: form.correo,
      Telefono: form.telefono,
      Direccion: form.direccion,
    };

    if (!validacionesComunes.validarEmpty(campos)) return false;

    if (!validacionesComunes.validarNombre(campos.Nombre)) return false;
    if (!validacionesComunes.validarEmail(campos.Correo)) return false;

    if (!validacionesComunes.validarTelefono(campos.Telefono, selectedCountry))
      return false;

    return true;
  },
};

const validacionesProductos = {
  validarCampos(form) {
    const esMateriaPrima = form.tipo === 'materia_prima';
    const esProductoTerminado = form.tipo === 'producto_terminado';

    const camposBase = {
      Código: form.codigo_producto,
      Nombre: form.nombre,
      Descripción: form.descripcion,
      "Unidad de Medida": form.unidad_medida,
    };

    if (!esProductoTerminado) {
      camposBase.Proveedor = form.proveedor;
    }

    if (!esMateriaPrima) {
      camposBase.Impuesto = form.impuesto;
      camposBase["Precio Unitario"] = form.precio_unitario;
    }

    if (!validacionesComunes.validarEmpty(camposBase)) return false;

    const longitudPattern = /^.{3,20}$/;
    const alfanumericoPattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s]+$/;

    if (!longitudPattern.test(camposBase.Código)) {
      notis("warning", "El código debe contener entre 3 y 20 caracteres.");
      return false;
    }

    if (!alfanumericoPattern.test(camposBase.Código)) {
      notis("warning", "El código tiene caracteres no permitidos");
      return false;
    }

    const nombrePattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s\-()]+$/;
    if (!nombrePattern.test(camposBase.Nombre)) {
      notis(
        "warning",
        "El nombre solo puede contener letras, números, guiones y paréntesis"
      );
      return false;
    }

    if (!validacionesComunes.validarDescripcion(camposBase.Descripción))
      return false;

    if (!esProductoTerminado && !validacionesComunes.validarSelect(camposBase.Proveedor, "Proveedor"))
      return false;

    if (!esMateriaPrima) {
      if (!validacionesComunes.validarSelect(camposBase.Impuesto, "Impuesto"))
        return false;

      if (
        !validacionesComunes.validarNumero(
          camposBase["Precio Unitario"],
          "Precio Unitario"
        )
      )
        return false;

      const precioMayorista = form.precio_mayorista;
      const cantidadMayoreo = form.cantidad_activar_mayorista;

      if (precioMayorista !== "" && precioMayorista !== null && precioMayorista !== undefined) {
        if (!validacionesComunes.validarNumero(precioMayorista, "Precio Mayorista"))
          return false;
        if (parseFloat(precioMayorista) >= parseFloat(form.precio_unitario)) {
          notis("warning", "El precio mayorista debe ser menor que el precio unitario");
          return false;
        }
      }

      if (cantidadMayoreo !== "" && cantidadMayoreo !== null && cantidadMayoreo !== undefined) {
        if (!Number.isInteger(Number(cantidadMayoreo)) || Number(cantidadMayoreo) <= 0) {
          notis("warning", "La cantidad para activar precio mayorista debe ser un número entero positivo");
          return false;
        }
      }
    }

    if (
      !validacionesComunes.validarSelect(
        camposBase["Unidad de Medida"],
        "unidad de medida"
      )
    )
      return false;

    return true;
  },

  validarCategorias(categorias) {
    if (!Array.isArray(categorias)) {
      notis("warning", "No se han definido las categorías");
      return false;
    }

    if (categorias.length === 0) {
      notis("warning", "Debe seleccionar al menos una categoría");
      return false;
    }

    return true;
  },
};

const validacionesClientes = {
  validarCampos(form, selectedCountry) {
    const campos = {
      Nombre: form.nombre_completo,
      Correo: form.correo,
      Direccion: form.direccion,
      Telefono: form.telefono,
    };

    if (!validacionesComunes.validarEmpty(campos)) return false;
    if (!validacionesComunes.validarNombre(campos.Nombre)) return false;
    if (!validacionesComunes.validarEmail(campos.Correo)) return false;
    if (!validacionesComunes.validarDireccion(campos.Direccion)) return false;
    if (!validacionesComunes.validarTelefono(campos.Telefono, selectedCountry))
      return false;
    if (form.rtn && !validacionesComunes.validarRTN(form.rtn)) return false;

    return true;
  },
};

const validacionesProveedores = {
  validarCampos(form, selectedCountry) {
    const campos = {
      Nombre: form.nombre,
      Telefono: form.telefono,
      Correo: form.correo,
      Direccion: form.direccion,
    };

    if (!validacionesComunes.validarEmpty(campos)) return false;
    if (!validacionesComunes.validarNombre(campos.Nombre)) return false;
    if (!validacionesComunes.validarTelefono(campos.Telefono, selectedCountry))
      return false;
    if (!validacionesComunes.validarEmail(campos.Correo)) return false;
    if (!validacionesComunes.validarDireccion(campos.Direccion)) return false;

    return true;
  },
};

const validacionesConfigPage = {
  validarCamposConfiguracion(form, isPassEdit, selectedCountry) {
    const campos = {
      "Nombre de usuario": form.nombre_usuario,
      Telefono: form.telefono,
      Direccion: form.direccion,
    };

    // Validaciones básicas siempre
    if (!validacionesComunes.validarEmpty(campos)) return false;

    const usernamePattern = /^[a-zA-Z0-9_]+$/;
    if (!usernamePattern.test(campos["Nombre de usuario"])) {
      notis(
        "warning",
        "El nombre de usuario solo puede contener letras, números y guiones bajos"
      );
      return false;
    }

    if (
      campos["Nombre de usuario"].length < 3 ||
      campos["Nombre de usuario"].length > 50
    ) {
      notis(
        "warning",
        "El nombre de usuario debe tener entre al menos 3 caracteres"
      );
      return false;
    }

    if (!validacionesComunes.validarTelefono(campos.Telefono, selectedCountry))
      return false;
    if (!validacionesComunes.validarDireccion(campos.Direccion)) return false;

    // Solo validar contraseñas si isPassEdit es true
    if (isPassEdit) {
      // Agregar campos de contraseña al objeto campos solo si estamos en modo edición de contraseña
      campos.Contraseña = form.contraseña;
      campos["Contraseña nueva"] = form.contraseña_nueva;
      campos["Confirmar contraseña"] = form.contraseña_confirm;

      // Validar que los campos no estén vacíos
      if (!validacionesComunes.validarEmpty(campos)) return false;

      // Validar la contraseña nueva
      if (
        !validacionesComunes.validarPasswordSegura(campos["Contraseña nueva"])
      )
        return false;

      // Validar que las contraseñas coincidan
      if (
        !validacionesComunes.validarPass(
          campos["Contraseña nueva"],
          campos["Confirmar contraseña"]
        )
      )
        return false;
    }

    return true;
  },

  validarCamposConfiguracionAvanzada(form) {
    const campos = {
      Nombre: form.nombre,
      Apellido: form.apellido,
      Correo: form.correo,
    };

    if (!validacionesComunes.validarEmpty(campos)) return false;

    if (!validacionesComunes.validarNombre(campos.Nombre)) return false;

    const nombrePattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{3,50}$/;
    if (!nombrePattern.test(form.apellido)) {
      notis(
        "warning",
        "El apellido debe contener solo letras y tener al menos 3 caracteres"
      );
      return false;
    }

    if (!validacionesComunes.validarEmail(campos.Correo)) return false;

    return true;
  },
};

const validacionesConfigSAR = {
  validarCAI(cai) {
    if (!cai || cai.trim().length === 0) {
      notis("warning", "El CAI es requerido");
      return false;
    }
    
    const caiLimpio = cai.trim().toUpperCase();
    
    // CAI debe tener mínimo 32 caracteres
    if (caiLimpio.length < 32) {
      notis("warning", `El CAI debe tener mínimo 32 caracteres. Actualmente tiene ${caiLimpio.length}.`);
      return false;
    }
    
    // Validar formato: números, letras A-F y guiones
    const caracteresPermitidos = /^[A-Fa-f0-9-]+$/;
    if (!caracteresPermitidos.test(caiLimpio)) {
      notis("warning", "El CAI solo puede contener números (0-9), letras (A-F) y guiones (-)");
      return false;
    }
    
    // Verificar que tenga al menos 5 guiones
    const guiones = (caiLimpio.match(/-/g) || []).length;
    if (guiones < 5) {
      notis("warning", "El CAI debe tener el formato correcto con guiones (ej: 214EC-AEB3F6-F14EA2-016327-9CB222-F4)");
      return false;
    }
    
    return true;
  },

  formatearRangoParaVisualizacion(rango) {
    // Eliminar guiones existentes
    const rangoLimpio = rango.replace(/-/g, "");
    
    if (rangoLimpio.length !== 16) {
      return null;
    }
    
    // Formatear como: XXX-XXX-XX-XXXXXXXX
    return `${rangoLimpio.slice(0, 3)}-${rangoLimpio.slice(3, 6)}-${rangoLimpio.slice(6, 8)}-${rangoLimpio.slice(8)}`;
  },

  validarFormatoRango(rango) {
    // Eliminar guiones para validación
    const rangoSinGuiones = rango.replace(/-/g, "");
    
    if (rangoSinGuiones.length !== 16) {
      notis("warning", `El rango debe tener exactamente 16 dígitos (sin contar guiones). Actualmente tiene ${rangoSinGuiones.length}.`);
      return false;
    }
    
    // Validar que todos sean números
    if (!/^\d{16}$/.test(rangoSinGuiones)) {
      notis("warning", "El rango debe contener solo números");
      return false;
    }
    
    return true;
  },

  validarCamposConfiguracion(form) {
    const campos = {
      "Número CAI": form.numero_CAI,
      "Rango inicial": form.rango_inicial,
      "Rango final": form.rango_final,
      "Fecha de autorización": form.fecha_autorizacion,
      "Fecha de vencimiento": form.fecha_vencimiento,
    };

    if (!validacionesComunes.validarEmpty(campos)) return false;
    
    // Validar CAI
    if (!this.validarCAI(campos["Número CAI"])) return false;

    // Limpiar guiones de los rangos
    const rangoInicialLimpio = campos["Rango inicial"].replace(/-/g, "");
    const rangoFinalLimpio = campos["Rango final"].replace(/-/g, "");

    if (!this.validarFormatoRango(rangoInicialLimpio)) return false;
    if (!this.validarFormatoRango(rangoFinalLimpio)) return false;

    // Validar que los primeros 8 dígitos sean iguales (establecimiento-punto-serie)
    const prefijoInicial = rangoInicialLimpio.slice(0, 8);
    const prefijoFinal = rangoFinalLimpio.slice(0, 8);
    
    if (prefijoInicial !== prefijoFinal) {
      notis("warning", "Los rangos deben pertenecer al mismo establecimiento, punto de emisión y serie");
      return false;
    }

    // Validar secuenciales (últimos 8 dígitos)
    const secuencialInicial = parseInt(rangoInicialLimpio.slice(8));
    const secuencialFinal = parseInt(rangoFinalLimpio.slice(8));
    
    if (secuencialInicial >= secuencialFinal) {
      notis("warning", "El rango inicial debe ser menor que el rango final");
      return false;
    }
    
    if (secuencialInicial < 1) {
      notis("warning", "El secuencial inicial debe ser mayor a 0");
      return false;
    }

    // Verificar que el rango no sea excesivamente grande
    if (secuencialFinal - secuencialInicial > 9999999) {
      notis("warning", "El rango no puede exceder 9,999,999 facturas");
      return false;
    }

    // Guardar rangos SIN guiones en el formulario para el backend
    form.rango_inicial = rangoInicialLimpio;
    form.rango_final = rangoFinalLimpio;

    // Validaciones de fecha
    const fechaAutorizacion = new Date(campos["Fecha de autorización"]);
    const fechaVencimiento = new Date(campos["Fecha de vencimiento"]);
    const fechaActual = new Date();
    fechaActual.setHours(0, 0, 0, 0);

    if (isNaN(fechaAutorizacion.getTime()) || isNaN(fechaVencimiento.getTime())) {
      notis("warning", "Las fechas ingresadas no son válidas");
      return false;
    }

    if (fechaVencimiento < fechaActual) {
      notis("warning", "La fecha de vencimiento no puede ser en el pasado");
      return false;
    }

    if (fechaVencimiento <= fechaAutorizacion) {
      notis("warning", "La fecha de vencimiento debe ser posterior a la fecha de autorización");
      return false;
    }

    return true;
  },

  validarRangoDisponible(rangoInicial, rangoFinal, rangoActual) {
    // Limpiar guiones de todos los rangos
    const rangoInicialLimpio = rangoInicial.replace(/-/g, "");
    const rangoFinalLimpio = rangoFinal.replace(/-/g, "");
    const rangoActualLimpio = rangoActual.replace(/-/g, "");

    // Obtener secuenciales (últimos 8 dígitos)
    const secuencialInicial = parseInt(rangoInicialLimpio.slice(8));
    const secuencialFinal = parseInt(rangoFinalLimpio.slice(8));
    const secuencialActual = parseInt(rangoActualLimpio.slice(8));

    if (secuencialActual < secuencialInicial || secuencialActual > secuencialFinal) {
      notis("warning", "El número actual está fuera del rango autorizado");
      return false;
    }

    // Calcular porcentaje usado
    const rangoTotal = secuencialFinal - secuencialInicial;
    const rangoUsado = secuencialActual - secuencialInicial;
    const porcentajeUsado = (rangoUsado / rangoTotal) * 100;

    if (porcentajeUsado > 80) {
      notis("warning", "Queda menos del 20% del rango disponible. Considere solicitar un nuevo CAI");
    }

    return true;
  },
};

export {
  validacionesComunes,
  validacionesUsuario,
  validacionesCategorias,
  validacionesSucursal,
  validacionesProductos,
  validacionesClientes,
  validacionesProveedores,
  validacionesConfigPage,
  validacionesConfigSAR,
};
